import { createElement } from 'react';

import seoPages from './seoPagesData.json';

const linkStyle = {
  color: '#8B98A8',
  fontWeight: 600,
  fontSize: 13,
  textDecoration: 'none',
  minHeight: 36,
  display: 'inline-flex',
  alignItems: 'center',
} as const;

const navStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 16,
  width: '100%',
} as const;

/** Real `<a href>` so Google can follow intent pages from the homepage. */
export function SeoExploreLinks() {
  return createElement(
    'nav',
    { 'aria-label': 'MoneyLens guides', style: navStyle },
    createElement(
      'style',
      null,
      'nav[aria-label="MoneyLens guides"] a:hover { color: #3DD6A4; }',
    ),
    seoPages.pages.map((page) =>
      createElement(
        'a',
        { key: page.slug, href: `/${page.slug}`, style: linkStyle },
        page.kicker,
      ),
    ),
  );
}
